function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { parseISO, isValid as isDateValid, format as formatDate } from "date-fns";
import { nanoid } from "nanoid";
import useField from "../hooks/internal/useField";
import { mergeProps } from "../utils/component";
import Field from "./internal/Field";
import InternalInput from "./internal/InternalInput";
import Grid from "./Grid";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = InternalInput.COLORS;
var DAY_MODES = ["none", "2-digits"];
var YEAR_MODES = ["2-digits", "4-digits"];
var DAY_REGEX = /^([012]?[1-9]|[123]0|31)$/;
var MONTH_REGEX = /^(0?[1-9]|1[012])$/;
var TWO_DIGITS_YEAR_REGEX = /^\d{2}$/;
var FOUR_DIGITS_YEAR_REGEX = /^(19|20|21)\d{2}$/;
var DEFAULT_PROPS = {
  color: InternalInput.DEFAULT_PROPS.color,
  dayMode: "2-digits",
  yearMode: "4-digits",
  disabled: false,
  optional: false,
  validate: function validate(value, _ref) {
    var isEmpty = _ref.isEmpty,
        dayMode = _ref.dayMode,
        yearMode = _ref.yearMode;

    if (isEmpty(value)) {
      return "Required";
    }

    var day = value.day,
        month = value.month,
        year = value.year;
    var errors = [];

    if (dayMode === "2-digits") {
      if (DAY_REGEX.test(day) === false) {
        errors.push("Day must be within 1-31.");
      }
    }

    if (MONTH_REGEX.test(month) === false) {
      errors.push("Month must be within 1-12.");
    }

    if (yearMode === "2-digits") {
      if (TWO_DIGITS_YEAR_REGEX.test(year) === false) {
        errors.push("Year must be within 00-99.");
      }
    } else {
      if (FOUR_DIGITS_YEAR_REGEX.test(year) === false) {
        errors.push("Year must be within 1900-2199.");
      }
    }

    if (dayMode === "2-digits" && errors.length === 0) {
      var twoDigitsDay = day.length === 1 ? "0".concat(day) : day;
      var twoDigitsMonth = month.length === 1 ? "0".concat(month) : month;

      if (isDateValid(parseISO("".concat(yearMode === "2-digits" ? "20".concat(year) : year, "-").concat(twoDigitsMonth, "-").concat(twoDigitsDay))) === false) {
        errors.push("Invalid date.");
      }
    }

    return errors;
  }
};
DatePicker.COLORS = COLORS;
DatePicker.DAY_MODES = DAY_MODES;
DatePicker.YEAR_MODES = YEAR_MODES;
DatePicker.DEFAULT_PROPS = DEFAULT_PROPS;

function getHelpText(value, dayMode, yearMode, defaultHelpText) {
  if (dayMode === "2-digits" && DAY_REGEX.test(value.day) === false || MONTH_REGEX.test(value.month) === false || yearMode === "2-digits" && TWO_DIGITS_YEAR_REGEX.test(value.year) === false || yearMode === "4-digits" && FOUR_DIGITS_YEAR_REGEX.test(value.year) === false) {
    return defaultHelpText;
  }

  var dayInt = dayMode === "2-digits" ? parseInt(value.day, 10) : 1;
  var monthInt = parseInt(value.month, 10);
  var yearInt = parseInt(value.year, 10);
  var date = new Date(yearMode === "2-digits" ? 2000 + yearInt : yearInt, monthInt - 1, dayInt);

  if (isNaN(date)) {
    return defaultHelpText;
  }

  return formatDate(date, dayMode === "2-digits" ? "d MMMM yyyy" : "MMMM yyyy");
}

function DatePicker(props) {
  var mergedProps = mergeProps(props, DEFAULT_PROPS, {}, {
    color: function color(_color) {
      return COLORS.includes(_color);
    },
    dayMode: function dayMode(_dayMode) {
      return DAY_MODES.includes(_dayMode);
    },
    yearMode: function yearMode(_yearMode) {
      return YEAR_MODES.includes(_yearMode);
    },
    disabled: function disabled(_disabled) {
      return typeof _disabled === "boolean";
    },
    optional: function optional(_optional) {
      return typeof _optional === "boolean";
    },
    "aria-labelledby": function ariaLabelledby(_ariaLabelledby) {
      return typeof _ariaLabelledby === "string" && _ariaLabelledby.trim() !== "";
    }
  });
  var name = mergedProps.name,
      label = mergedProps.label,
      dayMode = mergedProps.dayMode,
      yearMode = mergedProps.yearMode,
      helpTextProp = mergedProps.helpText,
      disabled = mergedProps.disabled,
      optional = mergedProps.optional,
      validate = mergedProps.validate,
      validateData = mergedProps.validateData,
      ariaLabelledby = mergedProps["aria-labelledby"],
      testId = mergedProps.testId;

  var _useState = useState(function () {
    return "date-picker-".concat(nanoid());
  }),
      _useState2 = _slicedToArray(_useState, 1),
      labelId = _useState2[0];

  var _useState3 = useState(function () {
    return "date-picker-aux-".concat(nanoid());
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      auxId = _useState4[0];

  var isEmpty = useCallback(function (_ref2) {
    var day = _ref2.day,
        month = _ref2.month,
        year = _ref2.year;
    return (dayMode === "none" || day.trim() === "") && month.trim() === "" && year.trim() === "";
  }, [dayMode]);
  var data = useMemo(function () {
    return _objectSpread({
      isEmpty: isEmpty,
      dayMode: dayMode,
      yearMode: yearMode
    }, validateData && {
      data: validateData
    });
  }, [isEmpty, dayMode, yearMode, validateData]);

  var _useField = useField("DatePicker", {
    name: name,
    disabled: disabled,
    optional: optional,
    validate: validate,
    data: data
  }),
      value = _useField.value,
      errors = _useField.errors,
      hasErrors = _useField.hasErrors,
      onFocus = _useField.onFocus,
      onBlur = _useField.onBlur,
      onChange = _useField.onChange;

  var helpText = useMemo(function () {
    return getHelpText(value, dayMode, yearMode, helpTextProp);
  }, [value, dayMode, yearMode, helpTextProp]);
  return ___EmotionJSX(Field, {
    optional: optional,
    disabled: disabled,
    label: label,
    labelId: labelId,
    renderLabel: ariaLabelledby === undefined,
    auxId: auxId,
    helpText: helpText,
    errors: errors,
    testId: testId
  }, ___EmotionJSX("div", {
    "aria-invalid": hasErrors ? "true" : null,
    "aria-labelledby": ariaLabelledby || labelId,
    "aria-describedby": helpText || hasErrors ? auxId : null
  }, ___EmotionJSX(Grid, {
    cols: dayMode === "none" && yearMode === "2-digits" ? 2 : dayMode === "2-digits" && yearMode === "4-digits" ? 4 : 3,
    colsGap: 1
  }, dayMode === "2-digits" && ___EmotionJSX(Grid.Item, {
    colSpan: 0
  }, ___EmotionJSX(InternalInput, {
    name: "".concat(name, ".day"),
    parentName: name,
    variant: "numeric",
    color: props.color,
    placeholder: "DD",
    maxLength: "2",
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value.day,
    onChange: onChange
  })), ___EmotionJSX(Grid.Item, {
    colSpan: dayMode === "2-digits" ? 1 : 0
  }, ___EmotionJSX(InternalInput, {
    name: "".concat(name, ".month"),
    parentName: name,
    variant: "numeric",
    color: props.color,
    placeholder: "MM",
    maxLength: "2",
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value.month,
    onChange: onChange
  })), ___EmotionJSX(Grid.Item, {
    colSpan: dayMode === "none" && yearMode === "2-digits" ? "1" : dayMode === "none" && yearMode === "4-digits" ? "1-2" : dayMode === "2-digits" && yearMode === "2-digits" ? "2" : "2-3"
  }, ___EmotionJSX(InternalInput, {
    name: "".concat(name, ".year"),
    parentName: name,
    variant: "numeric",
    color: props.color,
    placeholder: yearMode === "2-digits" ? "YY" : "YYYY",
    maxLength: yearMode === "2-digits" ? "2" : "4",
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value.year,
    onChange: onChange
  })))));
}

DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.oneOf(COLORS),
  label: PropTypes.string,
  dayMode: PropTypes.oneOf(DAY_MODES),
  yearMode: PropTypes.oneOf(YEAR_MODES),
  helpText: PropTypes.string,
  disabled: PropTypes.bool,
  optional: PropTypes.bool,
  validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  validateData: PropTypes.any,
  "aria-labelledby": PropTypes.string,
  testId: PropTypes.string
};
export default DatePicker;